// @flow
import * as React from 'react';
import { Router, withTranslation } from '@i18n';

import { useState } from 'react';

import {
  TREATMENT_COST_FLOW
} from '@routes';
import { useRouter } from 'next/router';

import {
  StyledCover,
  StyledSubHeading,
  StyledFlowButtonWrapper,
  StyledFlowButtonContainer,
  StyledFlowButton,
  StyledIconWrapper,
  StyledLabel,
  StyledHeading
} from './styles';

const HomeTreatmentPlan = ({
  t, isMobile, buttons, isTablet
}) => {
  const router = useRouter();
  /* eslint-disable no-nested-ternary */
  const [seeMore, setSeeMore] = useState(isMobile ? 9 : (isTablet ? 5 : 6));
  React.useEffect(() => {
    setSeeMore(isMobile ? 9 : isTablet ? 5 : 6);
  }, [isMobile, isTablet]);
  const handleTimeSelect = (updateParams = {}): void => {
    const baseparams = { path: 'name' };
    const {
      department
    } = router.query;

    const newparam = {
      ...baseparams,
      department,
      ...updateParams
    };
    Object.keys(newparam).forEach(key =>
      newparam[key] === undefined && delete newparam[key]);
    Router.pushRoute(TREATMENT_COST_FLOW, newparam);
  };


  return (
    <StyledCover>
      <StyledHeading>
        {t('BookTreatmentPlan')}
      </StyledHeading>
      <StyledSubHeading>
        {t('ChooseDepartment')}
      </StyledSubHeading>

      <StyledFlowButtonWrapper>
        {buttons.slice(0, seeMore).map(({ label, icon: Icon, value }) => (
          <StyledFlowButtonContainer
            key={value}
            onClick={() => {
              handleTimeSelect({ department: value });
            }}
          >
            <StyledFlowButton>
              <StyledIconWrapper>
                <Icon alt={label} />
              </StyledIconWrapper>
            </StyledFlowButton>
            <StyledLabel>{label}</StyledLabel>
          </StyledFlowButtonContainer>
        ))}
      </StyledFlowButtonWrapper>

      <StyledFlowButtonContainer
        onClick={() => {
          if (seeMore === 6
            || seeMore === 9 || seeMore === 5) { setSeeMore(buttons.length); } else {
            setSeeMore(isMobile ? 9 : isTablet ? 5 : 6);
          }
        }}
        seemore={seeMore}
      >
        <StyledLabel seemore={seeMore} underline>
          {seeMore === 6 || seeMore === 9 || seeMore === 5 ? t('Showmore') : t('Showless')}
        </StyledLabel>
      </StyledFlowButtonContainer>
    </StyledCover>
  );
};

export default withTranslation('FlowScreen')(HomeTreatmentPlan);
